// File: src/pages/OptimizeSitePage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Page,
  Layout,
  Card,
  TextContainer,
  Text,
  List,
  Box,
  Button,
} from '@shopify/polaris';

export default function OptimizeSitePage() {
  const navigate = useNavigate();

  return (
    <Page title="A/B Testing: Your Fast Track to Better Conversions" fullWidth>
      <Layout>
        {/* Header */}
        <Layout.Section>
          <Card sectioned>
            <TextContainer spacing="loose">
              <Text as="h1" variant="headingLg">
                A/B Testing: Your Fast Track to Better Conversions
              </Text>
              <Text as="p" variant="bodyMd">
                A/B testing lets you try out different versions of your pages — like changing button colors, headlines, or layouts — and see which one real visitors prefer. No guesswork, just data-driven decisions.
              </Text>
            </TextContainer>
          </Card>
        </Layout.Section>

        {/* Step 1 */}
        <Layout.Section>
          <Card title="Step 1: What is A/B Testing?" sectioned>
            <TextContainer spacing="tight">
              <Text as="p" variant="bodyMd">
                A/B testing lets you compare two or more versions of something on your website—like a button or headline—to see which one gets more clicks, signups, or sales.
              </Text>
              <Box background="surface" padding="4" borderRadius="4">
                <Text as="p" variant="bodyMd">
                  <Box as="span" fontWeight="bold">Example:</Box> You want to test if a <Box as="span" fontStyle="italic">red button</Box> gets more clicks than a <Box as="span" fontStyle="italic">blue button</Box>.
                </Text>
              </Box>
              <Text as="p" variant="bodySm" color="subdued">
                Every visitor will see just one version. We track what they do and show you which version performs better.
              </Text>
            </TextContainer>
          </Card>
        </Layout.Section>

        {/* Benefits */}
        <Layout.Section>
          <Card title="Why A/B Test?" sectioned>
            <List type="bullet">
              <List.Item>Identify what really resonates with your audience</List.Item>
              <List.Item>Reduce bounce rates and boost engagement</List.Item>
              <List.Item>Increase signups, sales, and revenue</List.Item>
              <List.Item>Make confident improvements based on real data</List.Item>
            </List>
          </Card>
        </Layout.Section>

        {/* CTA */}
        <Layout.Section>
          <Box paddingBlock="4" textAlign="center">
            <Button primary onClick={() => navigate('/ab-testing')}>
              Create Your First Test
            </Button>
          </Box>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
